module.exports = __webpack_public_path__ + "img/simple_loader.a4bc3449.webp";